import { render } from "./String.vue?vue&type=template&id=bde34c98&lang=pug"
import script from "./String.vue?vue&type=script&lang=ts"
export * from "./String.vue?vue&type=script&lang=ts"
script.render = render

export default script